import { DialogPositioningBehavior, DialogType } from '@tableau/widgets';
import React from 'react';

import {
  ModalInstance,
  ReactModalOptions,
  ReactModalService
} from '~src/commonInfra/dialogs/ReactModalService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { DeviceSizes } from '../../devicePreview/services/DevicePreviewService';
import { DevicePreviewModal, DevicePreviewModalProps } from '../components/DevicePreviewModal';

// TODO:
// Once the lightbox styles are flushed out, we should abstract it out into either its own class or
// as a lightbox option inside ReactModalService.
export namespace DevicePreviewModalBuilder {
  // Specific to Device Preview.  Usually, widgets will not require this sizing, but the viz viewer requires a position:absolute parent.
  const maxDeviceHeight: number = Object.keys(DeviceSizes).
    map(key => parseInt(DeviceSizes[key].height, 10)).
    reduce((maxValue, currentValue) => Math.max(maxValue, currentValue));
  const headerAndDeviceControlsHeight: number = 65;
  const bottomPadding: number = 18;
  const dialogHeight: number = maxDeviceHeight + headerAndDeviceControlsHeight + bottomPadding;

  function getDialogContent(vizPath: string, dismiss: () => void): JSX.Element {
    const devicePreviewModalProps: DevicePreviewModalProps = {
      vizPath: vizPath,
      dismiss: dismiss,
    };
    return React.createElement(DevicePreviewModal, devicePreviewModalProps);
  }

  function getDialogStyle(): React.CSSProperties {
    return {
      backgroundColor: CommonStyles.Colors.Grey40,
      fontSize: 14,
      color: CommonStyles.Colors.White,
      border: 'none',
    };
  }

  function getDialogBodyStyle(): React.CSSProperties {
    return {
      position: 'relative',
      height: dialogHeight,
      paddingTop: 18
    };
  }

  function getDevicePreviewModalOptions(vizPath: string, dismiss: () => void): ReactModalOptions{
    return {
      type: DialogType.Uber,
      dialogBodyStyle: getDialogBodyStyle(),
      dialogContent: getDialogContent(vizPath, dismiss),
      dialogStyle: getDialogStyle(),
      showCloseButton: true,
      positioningBehavior: DialogPositioningBehavior.Maximized,
      shouldReturnFocusOnClose: true
    };
  }

  export function openPreview(vizPath: string) {
    let modalInstance: ModalInstance;

    const dismiss = () => {
      modalInstance && modalInstance.dismiss();
    };

    const modalOptions: ReactModalOptions = getDevicePreviewModalOptions(vizPath, dismiss);

    modalInstance = ReactModalService.open(modalOptions);
  }
}
